import React from 'react';
import Customizer from './Customizer';

function App() {
  return <Customizer />;
}

export default App;
